import { useEffect, type DependencyList } from "react";

import type { IOts, OptionTs } from "@ps-bridge/interop";
import { ok, type Ok } from "@ps-bridge/ok";
import { runIO } from "@view/effects/effectRunner";
import * as Option from "@utils/Option";
import { ioEffect } from "@utils/effects/branded";

export const ioOptionNone = (): OptionTs<IOts<Ok>> => Option.none<IOts<Ok>>();
export const ioOptionSome = (io: IOts<Ok>): OptionTs<IOts<Ok>> => Option.some<IOts<Ok>>(io);
export const cleanupNone = ioOptionNone;
export const cleanupSome = ioOptionSome;

export const useIoEffectWithCleanup = (
    setup: IOts<OptionTs<IOts<Ok>>>,
    deps?: DependencyList,
): Ok => {
    const resolvedDeps = deps ?? [setup];
    useEffect(() => {
        const cleanup = Option.fold(runIO(setup), () => ioEffect(() => ok), (value) => value);
        return () => {
            runIO(cleanup);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps -- deps are caller-provided; setup is included in the fallback.
    }, resolvedDeps);
    return ok;
};
